<div class="agpr-formField" role="group" [attr.aria-labelledby]="field.headingId">
    <agpr-chart-color-picker-field
        [id]="id + '_color_' + index"
        *ngFor="let color of colorFieldModels; let index = index;"
        [field]="color"
        [userPreferenceColor]="color.userPreferenceColor"
        [block]="block"
        [doBorder]="true"
        (changes)="emitChanges($event)"
        [ariaLabel]="'Reports.formfield.metadata.colorSelection' | localize"
    ></agpr-chart-color-picker-field>
</div>
